'use strict';

import { tickAnswers } from './test_functions.js';
import { untick } from './test_functions.js';
import { showTestItem } from './test_functions.js';
import { showOrder } from './test_functions.js';
import { clearAnswers } from './test_functions.js';
import { clearBackground } from './test_functions.js';
import { clearTicksContent } from './test_functions.js';
import { showTicksContent } from './test_functions.js';
import { showDescr } from './test_functions.js';
import { answered } from './test_functions.js';
import { showNextBtn } from './test_functions.js';
import { showFinishBtn } from './test_functions.js';
import { hideNextBtn } from './test_functions.js';

function test() {

  const testItem = document.querySelectorAll('.test__item'),
    oneOfAnsw = document.querySelectorAll('.test__item span'),
    nextQ = document.querySelector('#next_q'),
    finish = document.querySelector('#finish_test'),
    ticks = document.querySelectorAll('.tick'),
    questNum = document.querySelectorAll('.qnum'),
    dr = document.querySelectorAll('.dr'),
    dw = document.querySelectorAll('.dw');

  tickAnswers(oneOfAnsw);

  const rightAnsw = document.querySelectorAll('.is_right');

  let itemIndex = 1;

  try {
    showTestItem(testItem, itemIndex);
  } catch(e) {}

  showOrder(questNum, testItem);

  function nextItem(n) {
    showTestItem(testItem, itemIndex += n);
    untick(testItem);
  }

  try {
    nextQ.addEventListener('click', () => {

      nextItem(1);
  
      clearAnswers(rightAnsw);
  
      clearBackground(ticks);
  
      showTicksContent(ticks);
  
      hideNextBtn(nextQ);
    });
  } catch(e) {}

  let descr = document.createElement('div');

  descr.classList.add('descr');

  let result = [];

  const arrDr = [],
    arrDw = [];

  dr.forEach(item => {
    arrDr.push(item.textContent);
  });

  dw.forEach(item => {
    arrDw.push(item.textContent);
  });

  testItem.forEach(elem => {
    elem.addEventListener('click', function checkAnswer(e) {
      if (e.target && e.target.classList.contains('is_right')) {

        result.push(1);

        clearTicksContent(ticks);

        e.target.innerHTML = '&#10004; ';

        e.target.parentNode.classList.add('right');

        descr.textContent = arrDr[itemIndex - 1];

        showDescr(e.target, descr);

        answered(elem);

        showNextBtn(itemIndex, testItem, nextQ);

        showFinishBtn(itemIndex, testItem, finish);
        
      } else if (e.target && e.target.classList.contains('is_wrong')) {

        clearTicksContent(ticks);

        e.target.innerHTML = '&#10006; ';

        rightAnsw.forEach(answer => {
          answer.innerHTML = '&#10004; ';
          answer.parentElement.classList.add('right');
        });

        e.target.parentNode.classList.add('wrong');

        descr.textContent = arrDw[itemIndex - 1];

        showDescr(e.target, descr);

        answered(elem);

        showNextBtn(itemIndex, testItem, nextQ);

        showFinishBtn(itemIndex, testItem, finish);
      }

      if (elem.classList.contains('ticked')) {
        elem.removeEventListener('click', checkAnswer);
      }

      restart.addEventListener('click', () => {
        elem.addEventListener('click', checkAnswer);
      });
    });
  });

  const resultTable = document.querySelector('#test_result'),
    restart = document.querySelector('#restart_test'),
    comments = document.querySelectorAll('.comment'),
    resultComment = document.createElement('p');

  try {
    finish.addEventListener('click', () => {

      untick(testItem);
  
      clearBackground(ticks);
  
      descr.remove();
  
      testItem[itemIndex - 1].classList.add('hide');
  
      testItem[itemIndex - 1].classList.remove('show');
  
      resultTable.classList.remove('hide');
  
      resultTable.innerHTML = `<p>Ваш результат: ${result.length} из ${testItem.length}</p>`;
  
        let comArr = [];
  
        comments.forEach(comment => {
          if (comment.textContent != '') {
            comArr.push(comment.textContent);
          }
        });
    
        if (result.length == testItem.length) {
          resultComment.textContent = comArr[0];
        } else if (result.length == testItem.length - 1) {
          resultComment.textContent = comArr[1];
        } else {
          resultComment.textContent = comArr[2];
        }
        resultTable.append(resultComment);
  
      finish.classList.add('hide');
  
      restart.classList.remove('hide');
    });
  } catch(e) {}

  try {
    restart.addEventListener('click', () => {

      clearAnswers(rightAnsw);
  
      showTicksContent(ticks);
  
      resultTable.classList.add('hide');
  
      restart.classList.add('hide');
  
      hideNextBtn(nextQ);
  
      result = [];
  
      ticks.forEach(tick => {
        tick.innerHTML = '? ';
      });
  
      itemIndex = 1;
  
      showTestItem(testItem, itemIndex);
    });
  } catch(e) {}
}

export default test;